import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Table, TabsSlide, Description } from '@quikr/ui';
import Amenities from '@quikr/ui/src/common/Amenities';
import AboutTemplate from '../AboutTemplate';
import { common } from '../../../gql/common';
import Location from '../../common/Location';

const VapHomesExtrainfo = (props) => {
  const { loading, error, data } = useQuery(common);
  if (loading || error) return null;
  const { isMobile } = data;
  const {
    attr,
    description,
    projectdetails,
    builderdetails,
    coordinates,
    title,
    amenities = [],
    furnishing = []
  } = props.data;
  const { positionY, top } = props;
  const tableMaxLength = isMobile ? 5 : 10;
  const tabsData = [];
  tabsData.push({
    id: 'Features',
    component: (
      <>
        <Table
          data={attr}
          showDivider
          maxLength={tableMaxLength}
          showViewMoreBtn={attr.length > tableMaxLength}
        />
      </>
    ),
    title: 'Features',
    type: 'component'
  });

  tabsData.push({
    id: 'About_Property',
    component: <Description content={description} maxLength={isMobile ? 380 : 700} />,
    title: 'About Property',
    type: 'component'
  });
  (furnishing.length || amenities.length) &&
    tabsData.push({
      id: 'Society_Amenities',
      component: (
        <>
          <Amenities type="Flat" isMobile={isMobile} data={furnishing} />
          <Amenities data={amenities} isMobile={isMobile} />
        </>
      ),
      heading: '',
      title: 'Amenities',
      type: 'component'
    });

  projectdetails &&
    tabsData.push({
      id: 'About_Project',
      component: (
        <AboutTemplate heading={'About Project'} isMobile={isMobile} data={projectdetails} />
      ),
      title: 'About Project',
      type: 'component'
    });

  builderdetails &&
    tabsData.push({
      id: 'About_Builder',
      component: (
        <AboutTemplate heading={'About Builder'} isMobile={isMobile} data={builderdetails} />
      ),
      title: 'About Builder',
      type: 'component'
    });

  coordinates.latitude && coordinates.longitude &&
    tabsData.push({
      id: 'Location',
      component: <Location coordinates={coordinates} title={title} />,
      title: 'Location',
      type: 'component'
    });

  return <TabsSlide data={tabsData} tabsPosition={true} positionY={positionY} top={top} />;
};

VapHomesExtrainfo.propTypes = {
  data: PropTypes.object,
  positionY: PropTypes.number,
  top: PropTypes.number,
  projectdetails: PropTypes.object
};

TabsSlide.defaultProps = {
  positionY: 160
};

export default React.memo(VapHomesExtrainfo);
